module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "health-card-list"
  }, [_c('div', {
    staticClass: "health-card-thumbnail"
  }, [_vm._l((_vm.healthCardList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "thumbnail-item",
      class: _vm.current === index ? 'item-selected' : '',
      on: {
        "click": function($event) {
          return _vm.goto(index)
        }
      }
    }, [(_vm.current === index) ? _c('img', {
      staticClass: "default-icon",
      attrs: {
        "src": require("../../../static/img/home/default_person_selected.png")
      }
    }) : _c('img', {
      staticClass: "default-icon",
      attrs: {
        "src": require("../../../static/img/home/default_person.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.holderName))]), _vm._v(" "), (_vm.current === index) ? _c('img', {
      staticClass: "down-icon",
      attrs: {
        "src": require("../../../static/img/home/down_selected_icon.png")
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.healthCardList.length < 3) ? _c('div', {
    staticClass: "thumbnail-item",
    class: _vm.current === _vm.healthCardList.length ? 'item-selected' : '',
    on: {
      "click": function($event) {
        return _vm.goto(_vm.healthCardList.length)
      }
    }
  }, [(_vm.current === _vm.healthCardList.length) ? _c('img', {
    staticClass: "default-icon",
    attrs: {
      "src": require("../../../static/img/home/card_add_active.png")
    }
  }) : _c('img', {
    staticClass: "default-icon card-add",
    attrs: {
      "src": require("../../../static/img/home/card_add_unselected.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }), _vm._v(" "), (_vm.current === _vm.healthCardList.length) ? _c('img', {
    staticClass: "down-icon mt",
    attrs: {
      "src": require("../../../static/img/home/down_selected_icon.png")
    }
  }) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "swiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    },
    on: {
      "slideChange": _vm.slideChange
    }
  }, [_vm._l((_vm.healthCardList), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card"
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.selectVoucher(item)
        }
      }
    }, [_c('health-card', {
      attrs: {
        "data": item
      }
    })], 1)])
  }), _vm._v(" "), (_vm.healthCardList.length < 3) ? _c('swiper-slide', [_c('img', {
    staticClass: "card-add",
    attrs: {
      "src": require("../../../static/img/home/health_card_add.png")
    },
    on: {
      "click": _vm.goAddVoucher
    }
  })]) : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071e2cd8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/health-card-swiper/swiper.vue
// module id = 778
// module chunks = 0